<ng-container *ngIf="stateIndicatorProperties?.label as label">
  <div
    class="d-flex align-items-center justify-center montserrat-font full-width full-height 
    {{ stateIndicatorProperties?.stateClass }}
    {{ stateIndicatorProperties?.customClass }}">
    <span>{{ label }}</span>
  </div>
</ng-container>
